import { render, staticRenderFns } from "./summaryTable.vue?vue&type=template&id=ccaa0ea4&scoped=true"
import script from "./summaryTable.vue?vue&type=script&lang=js"
export * from "./summaryTable.vue?vue&type=script&lang=js"
import style0 from "./summaryTable.vue?vue&type=style&index=0&id=ccaa0ea4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccaa0ea4",
  null
  
)

export default component.exports